import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { reportActions } from '../../store/reportStore';
import ReportExpander from "../common/reportExpander";
import ReportSection from '../common/reportSection';

class QuickReportComponent extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div style={{marginLeft:'1em'}}>
                    <ReportExpander allowExpandAll={false} allowSectionSelector={false} />
                </div>
                { this.props.sections && this.renderSections() }
            </React.Fragment>
        );
    };

    constructor(props) {
        super(props);
        this.state = { reloaded: false };
    }

    componentDidMount() {
        this.props.requestGetReportSettings(this.props.match.params.id, 'QuickAddressReport');
    };

    componentDidUpdate() {
        if (this.props.requestedReload === true && !this.state.reloaded) {
            this.props.requestGetReportSettings(this.props.match.params.id, 'QuickAddressReport');
            this.setState({ reloaded: true });
        }
        if (this.props.requestedReload === false && this.state.reloaded)
            this.setState({ reloaded: false });
    };

    componentWillUnmount() {
        this.props.onLeavingReport();
        if (this.props.sections)
            this.props.restoreConfig();
    };

    renderSections = () => {
        if (isNullOrUndefined(this.props.sections))
            return null;

        return (
            this.props.sections.filter(s => !s.hidden).map(s => <ReportSection key={s.id + '-' + s.orderId} sectionId={s.id} />)
        );
    };
}

export default withRouter(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(QuickReportComponent));